import { render, staticRenderFns } from "./material-accessories.vue?vue&type=template&id=0cf1e0b0&scoped=true&"
import script from "./material-accessories.vue?vue&type=script&lang=js&"
export * from "./material-accessories.vue?vue&type=script&lang=js&"
import style0 from "./material-accessories.vue?vue&type=style&index=0&id=0cf1e0b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf1e0b0",
  null
  
)

export default component.exports